import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { ReviewAutomationOverlayComponent } from '../automation-overlay/review-automation-overlay.component'

@Component({
  selector: 'app-review-automations-overlay',
  templateUrl: './review-automations-overlay.component.html',
  styleUrls: ['./review-automations-overlay.component.scss'],
})
export class ReviewAutomationsOverlayComponent implements OnInit {
  constructor(private dialog: DialogService, public dialogRef: MatDialogRef<ReviewAutomationsOverlayComponent>) {}

  ngOnInit(): void {}

  onAddAutomation() {
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
    })
  }
  close() {
    this.dialogRef.close()
  }
}
